import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeReferendumb2025 extends Component {
	render() {
		return (
			<div className="App">
				<EWH id="ewh-fascione-hp-referendum" repo='/elezioni/withub/electionday-2025/referendum/fascione-elezioni.html?cid=ewh-fascione-hp-referendum&amp;https%3A%2F%2Fmediaset.withub.it%2F' />
				<EWH id="ewh-referendum-italia" repo='/elezioni/withub/electionday-2025/referendum/dettaglio-italia.html?cid=ewh-referendum-italia&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
			</div>
		)
	}
}

export default HomeReferendumb2025
